import $ from 'jquery';

export default function starModule() {
  const starElement = $('.stars');
  if (starElement.length) {
    return import(/* webpackChunkName: "star" */ '../star')
      .then(({ default: Star }) => {
        const star = new Star();
        return star;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
